import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { signOut } from 'firebase/auth';
import auth from '../../firebase.init';
const Navbar = () => {
    const [user] = useAuthState(auth);
    const logout = () => {
        signOut(auth);
        localStorage.removeItem('accessToken');
    }
    const menuItems=<>
    <li><Link to='/'>Home</Link></li>
    <li><Link to='/blog'>Blogs</Link></li>
    {/* <li><Link to='/portfolio'>Portfolio</Link></li> */}
    <li>{user? <button className="btn btn-ghost" onClick={logout}>Sign out  {user?.displayName}</button>:<Link to='/login'>Login</Link>}</li>
    <li><Link to='/products'>Products</Link></li>
    <li><Link to='/services'>Services</Link></li>
    <li><Link to='/about'>About Us</Link></li>
    <li><Link to='/contact'>Contact Us</Link></li>
    {
        user && <li><Link to='/dashboard'>Dashboard</Link></li>
    }
    </>
    return (
        <div class="navbar bg-accent text-amber-400">
        <div class="navbar-start">
          <div class="dropdown">
            <label tabindex="0" class="btn btn-ghost lg:hidden">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
            </label>
            <ul tabindex="0" class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
             {menuItems}
            </ul>
          </div>
          <Link to='/' class="btn btn-ghost normal-case text-xl"> <img className='h-10 w-16 rounded-lg mx-5' src="https://i.ibb.co/Z2ZcVVs/328-3281952-the-carpenters-logo-carpenters-greatest-hits-removebg-preview.png" alt="" /> Carpenters-Hub</Link>
        </div>
        <div class="navbar-center hidden lg:flex">
          <ul class="menu menu-horizontal p-0">
            {menuItems}
          </ul>
        </div>
        <div className="navbar-end">
        <label tabindex="1" for="dashboard-sidebar"  class="btn btn-ghost lg:hidden">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
            </label>
        </div>
      </div>
    );
};

export default Navbar;